/**
 * Activa o desactiva secciones sin comentar código en las páginas.
 * Cambia a `true` la sección que quieras volver a mostrar.
 *
 * También puedes usar variables de entorno (REACT_APP_*):
 *   REACT_APP_SHOW_NOSOTROS_TRAYECTORIA=true
 *   REACT_APP_SHOW_NOSOTROS_EXPERTOS=true
 *   REACT_APP_SHOW_NOSOTROS_EQUIPO=true
 *   REACT_APP_SHOW_HUB_PERUMIN=true
 *   REACT_APP_SHOW_HUB_NOVEDADES=true
 *   REACT_APP_SHOW_FLOATING_SCHEDULE=true
 */
const fromEnv = (key) => process.env[key] === 'true';

export const sectionVisibility = {
  nosotros: {
    trayectoriaVideo:
      fromEnv('REACT_APP_SHOW_NOSOTROS_TRAYECTORIA') || false,
    experts: fromEnv('REACT_APP_SHOW_NOSOTROS_EXPERTOS') || false,
    teamInAction: fromEnv('REACT_APP_SHOW_NOSOTROS_EQUIPO') || false,
  },
  hub: {
    peruminVideo: fromEnv('REACT_APP_SHOW_HUB_PERUMIN') || false,
    novedades: false,
  },
  floatingButtons: {
    schedule: fromEnv('REACT_APP_SHOW_FLOATING_SCHEDULE') || false,
  },
};
